import { Icon, type IconName } from './Icon.js';
import { cx } from './cx.js';

export interface TabItem<T extends string = string> {
  id: T;
  label: string;
  icon?: IconName;
}

/** Contrôle segmenté pour basculer entre 2 à 5 vues d'un même panneau. */
export function Tabs<T extends string>({ items, value, onChange, 'aria-label': ariaLabel }: {
  items: Array<TabItem<T>>;
  value: T;
  onChange?: (id: T) => void;
  'aria-label'?: string;
}) {
  return (
    <div className="pl-tabs" role="tablist" aria-label={ariaLabel}>
      {items.map((it) => {
        const on = it.id === value;
        return (
          <button
            key={it.id}
            type="button"
            role="tab"
            aria-selected={on}
            className={cx('pl-tab', on && 'pl-tab-on')}
            title={it.label}
            onClick={() => onChange?.(it.id)}
          >
            {it.icon && <Icon name={it.icon} size={14} />}
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
